<div class="box-dash">
  <div class="row talent-payroll"
       style="border:1px solid #d4dadd; margin-top:10px;">
    <div class="col-lg-2 ps-0 pe-0">
      <div class="row">
        <div class="tpm-timesheet-action-container">
          <div class="action-element" *ngIf="operationTalentDept"
               authenticate-user="timesheet.create">
            <a class="btn btn-primary btn-block  action-wrapper talent-payroll-btncls"
               (click)="openCreateTimeSheetModal()">
              + Create Timesheet
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4 ps-0 pe-0">
      <div class="row">
        <div class="col-sm-12">
          <div>
            <input type="text"
                   [(ngModel)]="queryContainer.query.searchTerm.description"
                   placeholder="CONTACT OR TIMESHEET"
                   class="timesheetTextbox dashboard-contact" />
            <input type="button" class="btn btn-primary action-wrapper timesheetSearchButton"
                   (click)="search()"
                   [disabled]="searchButtonDisable" value="Search" />
            <input type="button" class="btn btn-secondary action-wrapper timesheetSearchButton"
                   (click)="reset()" value="Reset" />
          </div>
        </div>

      </div>
    </div>
    <div class="col-lg-6">
      <div class="dashboard-operationtalent col-sm-12">
        <div class="dashboard-operationtalentstatus" *ngFor="let dept of departments">
          <div class="timesheet-legend-status timesheet-status-{{dept.externalKey}}"></div>
          <div class="timesheet-legend-text">{{dept.name}}</div>
        </div>
        <div class="dashboard-operationtalentstatus">
          <div class="timesheet-legend-status timesheet-status-approved"></div>
          <div class="timesheet-legend-text">
            Approved
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
